import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

import { VMSACandidateLookupComponent } from './vmsa-candidate-lookup.component';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [VMSACandidateLookupComponent],
  exports: [VMSACandidateLookupComponent],
  providers: []
})
export class VMSACandidateLookupModule { }
